<template>
    <div class="annt-doc-wrapper">
        <el-dropdown @command="handlerSelete" class="lang-seletor" trigger="click">
            <el-button type="text" icon="el-icon-document">资料中心</el-button>
            <template #dropdown>
                <el-dropdown-menu class="doc-dropdown">
                    <el-dropdown-item v-for="item in dpData" :key="item.dictField" :command="item.dictField">{{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
<script>
import { onMounted, reactive, toRefs } from 'vue';
import { dictWithUrl } from '@/components/api/api.js';
import { dpData } from './config';

export default {
    name: 'AnntDocCenter',
    setup() {
        /** 数据 */
        const state = reactive({
            dictData: {},
            dpData
        });

        /** 选中下拉选项 */
        const handlerSelete = command => {
            window.open(state.dictData[command], '_blank');
        };

        /** 数据字典数据 */
        const getDictData = () => {
            dictWithUrl('NTP_DATA_CENTER_IMPORT').then(res => {
                if (res && +res.code === 0) {
                    state.dictData = res.data.NTP_DATA_CENTER_IMPORT;
                }
            });
        };

        onMounted(getDictData);

        return {
            ...toRefs(state),
            handlerSelete
        };
    }
};
</script>
<style lang="less">
.annt-doc-wrapper {
    .icon-button {
        font-size: 14px;
    }
}
.doc-dropdown {
    padding: 8px 0;
    li {
        padding: 4px 16px;
    }
}
</style>
